<template>
  <BaseShowEditRadio
    v-model="selectedValues"
    :edition-mode="editionMode"
    :label="$t('attributes.payment_origin')"
    name="payment_origin"
    :options="paymentOrigins"
    :errors="errors"
    :required="required"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import BaseShowEditRadio from '@c/addf-package/components/BaseShowEditRadioGroup/BaseShowEditRadio.vue'

export default {
  name: 'SelectPaymentOrigins',
  components: { BaseShowEditRadio },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters('metadata', {
      paymentOrigins: 'getPaymentOriginsMetadata'
    }),
    selectedLabel() {
      return this.paymentOrigins.find(
        (paymentOrigin) => paymentOrigin.id === this.modelValue
      )?.name
    }
  }
}
</script>
